module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-dialog', {
    attrs: {
      "title": "分店信息",
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分店名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入分店名称"
    },
    model: {
      value: (_vm.formparams.name),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "name", $$v)
      },
      expression: "formparams.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分店地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入分店详细地址"
    },
    model: {
      value: (_vm.formparams.address),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "address", $$v)
      },
      expression: "formparams.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "地铁导航"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入地铁导航"
    },
    model: {
      value: (_vm.formparams.metroroute),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "metroroute", $$v)
      },
      expression: "formparams.metroroute"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "公交导航"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入公交导航"
    },
    model: {
      value: (_vm.formparams.transitlot),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "transitlot", $$v)
      },
      expression: "formparams.transitlot"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "停车场数量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入停车场数量信息"
    },
    model: {
      value: (_vm.formparams.parkinglotdetails),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "parkinglotdetails", $$v)
      },
      expression: "formparams.parkinglotdetails"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "停车场收费信息"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入停车场收费信息"
    },
    model: {
      value: (_vm.formparams.parkinglotcharge),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "parkinglotcharge", $$v)
      },
      expression: "formparams.parkinglotcharge"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "周围环境信息"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入周围环境信息"
    },
    model: {
      value: (_vm.formparams.groundfacilities),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "groundfacilities", $$v)
      },
      expression: "formparams.groundfacilities"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "场地照明信息"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入场地照明信息"
    },
    model: {
      value: (_vm.formparams.lightingfacilities),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "lightingfacilities", $$v)
      },
      expression: "formparams.lightingfacilities"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "场地配置信息"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入场地配置信息"
    },
    model: {
      value: (_vm.formparams.restfacilities),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "restfacilities", $$v)
      },
      expression: "formparams.restfacilities"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分店说明"
    }
  }, [_c('editor-bar', {
    attrs: {
      "isClear": _vm.isClear
    },
    model: {
      value: (_vm.formparams.venuedetails),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "venuedetails", $$v)
      },
      expression: "formparams.venuedetails"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客服电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客服电话",
      "maxlength": "50"
    },
    model: {
      value: (_vm.formparams.phone),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "phone", $$v)
      },
      expression: "formparams.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    ref: "uploadElement",
    attrs: {
      "label": "分店图片",
      "required": "",
      "prop": ""
    }
  }, [_c('el-upload', {
    ref: "upload",
    class: {
      uploaderNone: _vm.hideUpload
    },
    attrs: {
      "action": "aa",
      "list-type": "picture-card",
      "auto-upload": false,
      "http-request": _vm.uploadFile,
      "file-list": _vm.fileList,
      "multiple": "",
      "limit": 1,
      "on-change": _vm.onChange,
      "on-remove": _vm.handleRemove,
      "accept": "image/png,image/gif,image/jpg,image/jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v("\n          *提示*：为了更好的用户体验，图片请提供320*160像素，文件大小不超过500kb。\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上/下线"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "上线",
      "inactive-text": "下线"
    },
    model: {
      value: (_vm.formparams.isWeb),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "isWeb", $$v)
      },
      expression: "formparams.isWeb"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "82vh",
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "分店名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imgaddress",
      "label": "分店地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "imgphone",
      "label": "分店电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分店图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "imgList",
          staticStyle: {
            "width": "200px",
            "height": "100px"
          },
          attrs: {
            "src": 'http://zlesp.zlydgy.cn:8091/images/' + scope.row.shopImg,
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上线状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isWeb == 1) ? _c('div', [_vm._v("上线")]) : _vm._e(), _vm._v(" "), (scope.row.isWeb == 0) ? _c('div', [_vm._v("下线")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分店说明"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top",
            "width": "300px"
          }
        }, [_c('p', {
          staticStyle: {
            "width": "300px"
          },
          domProps: {
            "innerHTML": _vm._s(scope.row.venuedetails)
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-tag', {
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("分店说明")])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-416de8aa"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/configurable/shopList.vue
// module id = 599
// module chunks = 70